var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.007,
    height: 17.921,
    viewBox: "0 0 22.007 17.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4377",
    "data-name": "Group 4377",
    transform: "translate(-764.497 -411.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(-3.274 1.21)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(775.274 422.79)",
    fill: "#88b151",
    fontSize: 10,
    fontFamily: "Muli-Black, Muli",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-refresh-cw",
    "data-name": "Icon feather-refresh-cw",
    transform: "translate(763.703 407.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10678",
    "data-name": "Path 10678",
    d: "M31.116,6v5.616H25.5",
    transform: "translate(-9.023 -0.563)",
    fill: "none",
    stroke: "#88b151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10679",
    "data-name": "Path 10679",
    d: "M1.5,26.616V21H7.116",
    transform: "translate(0 -6.202)",
    fill: "none",
    stroke: "#88b151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10680",
    "data-name": "Path 10680",
    d: "M3.849,10.118a8.424,8.424,0,0,1,13.9-3.145l4.343,4.081M1.5,14.8l4.343,4.081a8.424,8.424,0,0,0,13.9-3.145",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#88b151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.8b5fea6363fe7bf74cc012481cde90b0.svg";
export { ForwardRef as ReactComponent };